import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
interface Testimonial {
  name: string;
  initials: string;
  color: string;
  rating: number;
  text: string;
  tag?: string;
}
const testimonials: Testimonial[] = [{
  name: 'Martín G.',
  initials: 'MG',
  color: 'bg-crimson/20 text-crimson',
  rating: 5,
  text: 'Llevaba años siendo "el amigo perfecto". Después de leer el manual, entendí exactamente qué estaba haciendo mal. En dos semanas ya noté un cambio brutal en cómo me trataban las mujeres.',
  tag: 'Resultado en 2 semanas'
}, {
  name: 'Carlos R.',
  initials: 'CR',
  color: 'bg-blue-500/20 text-blue-400',
  rating: 5,
  text: 'No es manipulación. Es entender cómo funciona la atracción de verdad. Ojalá hubiera leído esto hace 10 años. Mi confianza cambió completamente.'
}, {
  name: 'Diego L.',
  initials: 'DL',
  color: 'bg-green-500/20 text-green-400',
  rating: 5,
  text: 'El audio de mentalidad es increíble. Lo escucho todas las mañanas. Pero el manual en sí es oro puro. Cada página tiene algo que podés aplicar ese mismo día.',
  tag: 'Bonus favorito: Audio'
}, {
  name: 'Alejandro M.',
  initials: 'AM',
  color: 'bg-purple-500/20 text-purple-400',
  rating: 5,
  text: 'Probé de todo: cursos de YouTube, coaches, libros de autoayuda. Nada me dio un sistema claro como este. Las 3 fases son geniales porque sabés exactamente qué hacer en cada momento.'
}, {
  name: 'Sebastián P.',
  initials: 'SP',
  color: 'bg-gold/20 text-gold',
  rating: 5,
  text: 'La guía de lenguaje corporal sola vale más que todo lo que pagué. Cambié mi postura, mi forma de mirar, y la diferencia fue inmediata. Las mujeres lo notan.',
  tag: 'Compra Verificada'
}, {
  name: 'Nicolás F.',
  initials: 'NF',
  color: 'bg-orange-500/20 text-orange-400',
  rating: 5,
  text: 'Tenía 34 años y nunca había tenido una relación seria. No porque fuera feo sino porque no sabía generar atracción. Este manual me cambió la vida. Literal.'
}, {
  name: 'Fernando T.',
  initials: 'FT',
  color: 'bg-teal-500/20 text-teal-400',
  rating: 5,
  text: 'Lo mejor es que no te pide ser alguien que no sos. Al contrario, te enseña a ser vos mismo pero de una forma que genera interés real. Muy recomendado.'
}, {
  name: 'Rodrigo V.',
  initials: 'RV',
  color: 'bg-pink-500/20 text-pink-400',
  rating: 5,
  text: 'Las 15 frases prohibidas son una locura. Las usé el fin de semana pasado y la reacción fue completamente diferente a lo que estaba acostumbrado. Funciona.',
  tag: 'Resultado inmediato'
}];
export function SocialProofSection() {
  return <section className="py-20 sm:py-28 bg-secondary" data-id="element-165">
      <div className="max-w-6xl mx-auto px-5 sm:px-6" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-167">
          <p className="text-crimson font-bold text-sm uppercase tracking-[0.2em] mb-4" data-id="element-168">
            Testimonios reales
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-169">
            Lo que dicen los que ya lo probaron
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto" data-id="element-170">
            Más de 2,847 hombres ya transformaron su vida con este sistema.
          </p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5" data-id="element-171">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="break-inside-avoid bg-primary rounded-xl border border-white/5 p-6 hover:border-crimson/15 transition-colors duration-300" data-id="element-172">
              {/* Header: Avatar + Name + Rating */}
              <div className="flex items-center gap-3 mb-4" data-id="element-173">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${t.color}`} data-id="element-174">
                  {t.initials}
                </div>
                <div className="flex-1 min-w-0" data-id="element-175">
                  <p className="text-white font-semibold text-sm" data-id="element-176">{t.name}</p>
                  <div className="flex items-center gap-1" data-id="element-177">
                    {[...Array(t.rating)].map((_, i) => <Star key={i} size={11} className="text-yellow-400 fill-yellow-400" data-id="element-178" />)}
                  </div>
                </div>
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-179">
                "{t.text}"
              </p>

              {/* Tag / Verified */}
              <div className="flex items-center gap-2" data-id="element-180">
                <ShieldCheck size={13} className="text-green-500" data-id="element-181" />
                <span className="text-[11px] text-green-400/80 font-medium" data-id="element-182">
                  {t.tag || 'Compra Verificada'}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}